let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i5W5w")).then(() => parcelRequire('7tdkn'));